module.exports = __webpack_public_path__ + "img/8.4065f352.png";